import { render, staticRenderFns } from "./promo-ag-grid.vue?vue&type=template&id=37bebd3a&scoped=true"
import script from "./promo-ag-grid.vue?vue&type=script&lang=js"
export * from "./promo-ag-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bebd3a",
  null
  
)

export default component.exports